<div class="row justify-content-center align-items-center">
    <div class="col-lg-6 col-sm-8">
      <div class="card p-4 shadow border">
        <div class="card-title text-center text-primary mb-4">
          <h4>Verificar contraseña</h4>
        </div>
        <div class="card-body">
          <form [formGroup]="formPassword">
         
              <div class="text-center pb-3 text-secondary">Ingrese su contraseña para confirmar el débito de su cuenta:</div>
             
              <div class="form-group position-relative d-flex">
                <input
                  [type]="seePass ? 'text' : 'password'"
                  class="form-control text-center"
                  id="inputPassword"
                  placeholder="Contraseña"
                  formControlName="password"
                />
                <span
                  class="material-icons update-icon see-icon"
                  (click)="seePass = !seePass"
                >
                  {{ seePass ? "visibility_off" : "visibility" }}
                </span>
              </div>
              
            <div class="keyboard-footer">
                <button type="button" class="btn btn-light btn-block mr-3 mt-1" (click)="EmittCancel()">Cancelar</button>
                <button type="button" class="btn btn-primary btn-block" [disabled]="formPassword.invalid"
                  (click)="EmittPasswordValue()">Aceptar</button>
              </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  